export const sendQuery = async (formData, resetForm, setOpen, navigate) => {
  try {
    setOpen(true);
    const response = await fetch(
      `https://webtimate-backend-landing.vercel.app/api/send-mail`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error("API Error:", response.status, errorData);
      throw new Error(errorData.text || "Failed to submit form");
    }

    const res = await response.json();

    if (res.success) {
      setOpen(false);
      resetForm();
      navigate("/thankyou");
    } else {
      alert(res.text);
      setOpen(false);
    }

    return res;
  } catch (error) {
    console.error("Form submission error:", error);
    setOpen(false);
    alert(error.message || "Something went wrong. Please try again later.");
    return { success: false, text: error.message };
  }
};
